import { palettes, createUnifiedTheme } from '@backstage/theme';
import { Theme as Mui4Theme } from '@material-ui/core/styles';

import { PaletteOptions } from '@material-ui/core/styles/createPalette';

const enum RDC_COLOR_PALETTE {
  REALTOR_RED = '#d92228',
  REALTOR_RED_LIGHT_HUE = '#f05255',
}

const createUnifiedThemeWithOverrides = (palette: PaletteOptions) => {
  const baseTheme = createUnifiedTheme({
    palette,
  });

  const themeV4 = baseTheme.getTheme('v4') as Mui4Theme;
  themeV4.overrides = {
    ...themeV4.overrides,
    ...{
      BackstageHeader: {
        header: {
          backgroundImage: `url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='1368' height='400' fill='none'%3e%3cmask id='a' width='1368' height='401' x='0' y='0' maskUnits='userSpaceOnUse'%3e%3cpath fill='url(%23paint0_linear)' d='M437 116C223 116 112 0 112 0h1256v400c-82 0-225-21-282-109-112-175-436-175-649-175z'/%3e%3cpath fill='url(%23paint1_linear)' d='M1368 400V282C891-29 788 40 711 161 608 324 121 372 0 361v39h1368z'/%3e%3cpath fill='url(%23paint2_linear)' d='M1368 244v156H0V94c92-24 198-46 375 0l135 41c176 51 195 109 858 109z'/%3e%3cpath fill='url(%23paint3_linear)' d='M1252 400h116c-14-7-35-14-116-16-663-14-837-128-1013-258l-85-61C98 28 46 8 0 0v400h1252z'/%3e%3c/mask%3e%3cg mask='url(%23a)'%3e%3cpath fill='white' d='M-172-98h1671v601H-172z'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient id='paint0_linear' x1='602' x2='1093.5' y1='-960.5' y2='272' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='white'/%3e%3cstop offset='1' stop-color='white' stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear' x1='482' x2='480' y1='1058.5' y2='70.5' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='white'/%3e%3cstop offset='1' stop-color='white' stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient id='paint2_linear' x1='424' x2='446.1' y1='-587.5' y2='274.6' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='white'/%3e%3cstop offset='1' stop-color='white' stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient id='paint3_linear' x1='587' x2='349' y1='-1120.5' y2='341' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='white'/%3e%3cstop offset='1' stop-color='white' stop-opacity='0'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e\"),  linear-gradient(90deg, ${RDC_COLOR_PALETTE.REALTOR_RED}, ${RDC_COLOR_PALETTE.REALTOR_RED_LIGHT_HUE})`,
        },
      },
    },
  };

  return baseTheme;
};

const rdcThemeLight = createUnifiedThemeWithOverrides(palettes.light);
const rdcThemeDark = createUnifiedThemeWithOverrides(palettes.dark);

export { rdcThemeLight, rdcThemeDark };
